const n = "icon", i = {
  "icon-container": "icon-container",
  icon: n,
  "icon--rtl": "icon--rtl",
  "icon-container--inline": "icon-container--inline"
};
export {
  i as default,
  n as icon
};
